import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { FPData } from './footer-page.data';
import { ErrorWrapper } from '../@shared/models/response-wrapper.model';
import { RouteExecutor } from '../@core/application-router/route.executor';
import { ApplicationRouterService } from '../@core/application-router/application-router.service';
import { FormControl } from '@angular/forms';
import { FunctionModel } from '../@shared/models/function.model';
import { FooterPageService } from './footer-page.service';
import { CText } from '../@shared/models/text.model';
import { Clickable } from '../@shared/models/clickable.model';

@Component({
    selector: 'app-footer-page',
    templateUrl: './footer-page.component.html',
    styleUrls: ['./footer-page.component.scss'],
})
export class FooterPageComponent
    extends RouteExecutor
    implements OnInit, OnChanges
{
    loading = true;
    email = new FormControl('');
    @Input() filter: { [p: string]: string | string[] } = {};
    @Input() page = '';
    parameters: { [p: string]: string | string[] } = {};
    data: FPData | null | undefined = null;
    errors: ErrorWrapper[] = [];
    subscribeMessage = '';
    subscribeColor = '';
    breadcrumbs: Array<Clickable> = [];
    openAccordionIndex: number = -4;

    constructor(
        applicationRouterService: ApplicationRouterService,
        private footerService: FooterPageService
    ) {
        super(applicationRouterService);
        //  this.footerService.footerFilter.subscribe((res: any) => {

        //  });
        this.footerService.breadcrumb.subscribe((res: any) => {
            this.breadcrumbs = res;
            console.log(res);
        });
    }

    ngOnInit(): void {
        //  this.updateFooterPageData();
        // this.email = new FormControl('');
    }

    ngOnChanges() {
        // console.log('ng changes');
        // this.data = new FPData();
        // if (this.filter) {
        //   this.processLink(
        //     this.filter +
        //     (this.filter.toString().includes('?') ? '&' : '?') +
        //     'action=footer-filter',
        //   );
        // }
        this.footerService
            .updateFooter({ ...this.filter, page: this.page })
            .subscribe(res1 => {
                this.loading = false;
                if (res1?.success) {
                    this.data = res1?.data;
                    // this.data?.content.mostSearched.feed.forEach((res) => {
                    //             const div=6;
                    //
                    // });
                } else {
                    this.data = null;
                }
            });
    }

    // updateFooterPageData() {
    //   const subscriber = Subscriber.create<ResponseWrapper<FPData> | null>(
    //     value => {
    //       if (value?.success) {
    //         this.data = value.data;
    //         //   this.loading = false;
    //         console.log(this.data, 'data');
    //       } else {
    //         this.loading = false;
    //         this.data = null;
    //         plainToClassFromExist(this.errors, value?.errors);
    //       }
    //     },
    //     error => {
    //     },
    //     () => {
    //     },
    //   );
    //
    //   this.marcheAPIService
    //       .getRequest<ResponseWrapper<FPData> | null>(
    //           FooterPageComponent.FP_DATA_API,
    //           // { page: 'homePage' }
    //           this.parameters
    //       )
    //       .subscribe(subscriber);
    // }

    executeFunctionLink(id: string, query: { [p: string]: string | string[] }) {
        this.applicationRouterService
            .executeFunctionLink(id, query, {
                email: this.email.value,
            })
            .subscribe(
                res => {
                    this.updateState(res.data);
                },
                error => {},
                () => {}
            );
    }

    executePageLink(id: string, query: { [p: string]: string | string[] }) {
        if (query.action === 'footer-filter') {
            delete query.action;
            this.parameters = { page: id.replace('/', ''), ...query };
            //   this.updateFooterPageData();
        } else {
            super.executePageLink(id, query);
        }
    }

    updateState(response: FunctionModel) {
        if (!response) {
            return;
        }
        if (response.updateId === 'newsLetter') {
            this.subscribeMessage = response?.state?.message.text;
            this.subscribeColor = response?.state?.message.color;
        }
    }

    checkValidEmail() {
        const pattern =
            /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
        if (!pattern.test(this.email.value!.toString())) {
            this.email.setErrors({ error: 'Invalid Email' });
        } else {
            this.email.setErrors(null);
        }
    }

    externalLinksRedirect(link: string) {
        console.log(link);
        window.open(link, '_blank');
    }

    setAccordionState(index: number) {
        this.openAccordionIndex = index;
    }
}
